import React from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/AccountStatusDialog.css";
import gifSrc from "../../assets/images/waiting.gif";
import {
  PENDING_STATUS_MESSAGE,
  REJECT_STATUS_MESSAGE,
} from "../../utils/constants";
const AccountStatusDialog = ({ open, onClose, title, handleClick }) => {
  return (
    <Dialog
      open={open ?? false}
      PaperProps={{
        className: "account-status-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="account-status-dialog-close"
          onClick={onClose}
        />
        <div className="account-status-dialog-content">
          <div className="account-status-dialog-title-container">
            {title === REJECT_STATUS_MESSAGE && (
              <div className="account-status-dialog-title">
                Association Status
              </div>
            )}
            {title === PENDING_STATUS_MESSAGE && (
              <div className="account-status-dialog-gif-container">
                <img
                  src={gifSrc}
                  alt="loading"
                  className="account-status-dialog-gif"
                />
              </div>
            )}
            <div className="account-status-dialog-subtitle">{title}</div>
          </div>
          {title === REJECT_STATUS_MESSAGE && (
            <Button
              variant="contained"
              color="secondaryButton"
              onClick={handleClick}
            >
              Ok
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AccountStatusDialog;
